module.exports = __webpack_public_path__ + "img/temperature.523a02a0.png";